import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, NgModule, OnChanges, SimpleChanges, Component, Input } from '@angular/core';
@Component({
  selector: 'order-tags',
  templateUrl: 'order-tags.component.html',
  styles: [`
    .tag-container {
      float: left;
    }

    .tag {
    background: #000;
    color: #fff;
    padding: 0 5px 0 5px;
    margin-right: 3px;
    border-radius: 3px;
    font-weight: normal;
    font-size: 0.7em;
    }
`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class OrderTagsComponent implements OnChanges {
  @Input() order: any;

  tags: string[] = [];
  constructor(private ref: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['order'] && (changes['order'].firstChange || changes['order'].currentValue != changes['order'].previousValue)) {
      this.tags = [];

      if (this.order) {
        if (this.order.isVoid) {
          this.tags.push('VOID');
        }

        if (this.order.isCanceled) {
          this.tags.push('CANCELED');
        }

        if (this.order.dryRun === 2) {
          this.tags.push('DRY RUN');
        }

        if (this.order.pickupCarrierTransportResult && this.order.pickupCarrierTransportResult.length && this.order.pickupCarrierTransportResult.length > 0 && this.order.deliveryCarrierTransportResult && this.order.deliveryCarrierTransportResult.length && this.order.deliveryCarrierTransportResult.length > 0) {
          if (this.order.pickupCarrierTransportResult.indexOf(2) !== -1 || this.order.pickupCarrierTransportResult.indexOf(4) !== -1 || this.order.deliveryCarrierTransportResult.indexOf(2) !== -1 || this.order.deliveryCarrierTransportResult.indexOf(4) !== -1) {
            this.tags.push('LATE');
          }

          if (this.order.pickupCarrierTransportResult.indexOf(7) !== -1 || this.order.deliveryCarrierTransportResult.indexOf(7) !== -1) {
            this.tags.push('CLAIM');
          }
        }
      }

      this.ref.markForCheck();
    }
  }
}



@NgModule({
  declarations: [
    OrderTagsComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OrderTagsComponent,
  ]
})
export class OrderTagsModule { }

